"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATE_RULES = void 0;
exports.getStateRules = getStateRules;
const CA_1 = require("./states/CA");
/**
 * Per-state accumulation rules, keyed by `Facility.state` (the two-letter
 * abbreviation). A state's rules replace the federal ones covering the same
 * limit — see `layerRules`. Anything a state doesn't cover keeps the federal
 * limit.
 *
 * Only CA today. Adding a state means adding one array under `states/` and
 * registering it here; nothing else changes. The numbers in a state's array
 * are regulatory law, so each one needs to be verified against that state's
 * own regulations — not assumed from another state's — before it's added.
 *
 * A state can replace a federal rule but, on its own, can't remove one:
 * leaving a limit out of a state's array falls through to the federal rule
 * for that key, which is only correct if the state actually follows federal
 * law there. A state that affirmatively imposes no limit for some key needs
 * a `NONE`-kind rule for it instead of just omitting the key.
 *
 * A satellite VOLUME limit's numbers are not merely descriptive: they are
 * what gets enforced. `satelliteVolumeLimitFor`, and its batched form
 * `resolveSatelliteVolumeLimits`, resolve the ruleset for the facility's own
 * state and both generator-status axes and return the winning VOLUME limit
 * (`wasteContainers/satelliteVolumeLimit.ts` in
 * `encamp-waste-data-access`). The area rollup derives everything from that
 * limit: `computeAreaVolume` / `isOverVolumeLimit` compare the area's totals
 * against its caps, and `resolveMoveDeadline` dates the move window off its
 * `moveWindowDays` (both in `wasteContainers/accumulationRollup.ts`). So a
 * state that sets different satellite caps, or a different move window, is
 * honoured end to end — displayed and enforced at its own numbers.
 *
 * One thing to get right when writing a state's array: applicability runs
 * before layering, so a state rule whose `condition` is unmet drops out
 * entirely and the federal rule for that key resurfaces for that
 * circumstance. A state's array therefore has to cover every circumstance for
 * any key it takes over — writing only a state's conditional variant, with no
 * unconditional base rule for the same key, silently hands its facilities the
 * federal limit whenever the condition does not match. That fallthrough is
 * deliberate and pinned by "still honours a state rule's condition" in
 * `getAccumulationRuleset.test.ts`.
 */
exports.STATE_RULES = { CA: CA_1.CA_RULES };
/**
 * The rules for a facility's state, or none for a state with no overrides.
 *
 * Matches `Facility.state` against the registry keys exactly, with no
 * normalization, because the column holds clean two-letter uppercase codes —
 * verified across production data — and the compliance engine normalizes to
 * that form upstream of anything that writes it. An unrecognized value falls
 * through to the federal baseline, which is also the right answer for a state
 * that has no overrides.
 */
function getStateRules(state) {
    if (state === null) {
        return [];
    }
    return exports.STATE_RULES[state] ?? [];
}
//# sourceMappingURL=state.js.map